module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/nl-card-drag.fcf625c3f53d6d0c3ff8.gif";